const tabs = [
  {
    id: 'top',
    name: 'TOP',
    title: 'ACROSS倉庫TOP',
    childs: []
  },
  {
    id: 'inventory',
    name: '在庫',
    title: '在庫',
    childs: [
      {
        id: 'inventory-inquiry',
        name: '在庫照会',
        title: '在庫照会',
        disabled: false
      },
      {
        id: 'inventory-end-of-month',
        name: '月末在庫',
        title: '月末在庫',
        disabled: false
      },
      {
        id: 'change-barcode',
        name: 'バーコード変更',
        title: 'バーコード変更',
        disabled: false
      }
    ]
  },
  {
    id: 'delivery',
    name: '納品',
    title: '納品',
    childs: [
      {
        id: 'delivery-status-inquiry',
        name: '納品状況照会',
        title: '納品状況照会',
        disabled: false
      },
      {
        id: 'direct-delivery',
        name: '直接納品',
        title: '直接納品',
        disabled: false
      },
      {
        id: 'amazon-delivery',
        name: 'Amazon返送納品',
        title: 'Amazon返送納品',
        disabled: false
      }
    ]
  },
  {
    id: 'shipping',
    name: '出荷',
    title: '出荷',
    childs: [
      {
        id: 'shipping-status-inquiry',
        name: '出荷状況照会',
        title: '出荷状況照会',
        disabled: false
      },
      {
        id: 'amazon-shipping',
        name: 'Amazon倉庫へ出荷',
        title: 'Amazon倉庫へ出荷',
        disabled: false
      },
      {
        id: 'multi-channel',
        name: 'マルチチャネル出荷',
        title: 'マルチチャネル出荷',
        disabled: false
      },
      {
        id: 'stock-crew',
        name: 'STOCKCREW倉庫へ出荷',
        title: 'STOCKCREW倉庫へ出荷',
        disabled: false
      }
    ]
  },
  {
    id: 'expense-details',
    name: '費用明細',
    title: '費用明細',
    childs: [
      {
        id: 'shipment-record',
        name: '出荷実績',
        title: '出荷実績',
        disabled: false
      },
      {
        id: 'storage-fees',
        name: '保管料等',
        title: '保管料等',
        disabled: false
      }
    ]
  },
  {
    id: 'settings',
    name: '倉庫設定',
    title: '倉庫設定',
    childs: [
      {
        id: 'price-diff',
        name: '受取金額差額設定',
        title: '受取金額差額設定',
        disabled: false
      }
    ]
  }
]

export default tabs



// WEBPACK FOOTER //
// ./src/common/warehouse-across-tabs.js